import React, { useState } from "react";
import styled from "styled-components";
import DeviceStatusButton from "./DeviceStatusButton";
import QRBindingModal from "./QRBindingModal";

const TestContainer = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const TestSection = styled.div`
  margin: 2rem 0;
  padding: 1.5rem;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  background: var(--bg-card);
`;

const TestTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: var(--text-primary);
`;

const TestRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
  padding: 1rem;
  background: var(--bg-primary);
  border-radius: 0.375rem;
`;

const TestLabel = styled.div`
  min-width: 200px;
  font-weight: 500;
`;

// Тестовые данные
const testHolders = [
  {
    id: "f090abcb-24b9-4237-a7ec-74c5a31bbfd4",
    name: "Тестовый Держатель",
  },
  {
    id: "cac5be77-1e7b-4edb-9ede-7de95d4a2cfe",
    name: "Иванй Ивановй",
  },
  {
    id: "58625f15-a0fb-4b88-88ec-be1860446daa",
    name: "Тест Юзер",
  },
];

const DeviceTestPage: React.FC = () => {
  const [deviceModal, setDeviceModal] = useState<{
    isOpen: boolean;
    holderId: string;
    holderName: string;
    deviceId?: string;
    deviceInfo?: any;
  }>({
    isOpen: false,
    holderId: "",
    holderName: "",
  });

  const handleBindDevice = (holderId: string) => {
    const holder = testHolders.find((h) => h.id === holderId);
    if (!holder) return;

    setDeviceModal({
      isOpen: true,
      holderId,
      holderName: holder.name,
    });
  };

  const handleRebindDevice = (deviceId: string, holderId: string) => {
    const holder = testHolders.find((h) => h.id === holderId);
    if (!holder) return;

    setDeviceModal({
      isOpen: true,
      holderId,
      holderName: holder.name,
      deviceId,
      deviceInfo: {
        platform: "android",
        model: "Test Device",
        lastSeenAt: new Date(),
      },
    });
  };

  const closeDeviceModal = () => {
    setDeviceModal({
      isOpen: false,
      holderId: "",
      holderName: "",
    });
  };

  return (
    <TestContainer>
      <h1>Тестирование системы устройств</h1>

      <TestSection>
        <TestTitle>Кнопки статуса устройств</TestTitle>
        <p style={{ color: "var(--text-secondary)", marginBottom: "1rem" }}>
          Тестирование компонента DeviceStatusButton для разных держателей:
        </p>

        {testHolders.map((holder) => (
          <TestRow key={holder.id}>
            <TestLabel>{holder.name}</TestLabel>
            <DeviceStatusButton
              holderId={holder.id}
              onBindDevice={handleBindDevice}
              onRebindDevice={handleRebindDevice}
            />
          </TestRow>
        ))}
      </TestSection>

      <TestSection>
        <TestTitle>Модальное окно</TestTitle>
        <p style={{ color: "var(--text-secondary)", marginBottom: "1rem" }}>
          Кликните на любую кнопку устройства выше, чтобы протестировать
          модальное окно.
        </p>

        <div style={{ display: "flex", gap: "1rem" }}>
          <button
            onClick={() => handleBindDevice(testHolders[0].id)}
            style={{
              padding: "0.5rem 1rem",
              background: "var(--accent-error)",
              color: "#ffffff",
              border: "none",
              borderRadius: "0.375rem",
              cursor: "pointer",
            }}
          >
            Тест привязки (красная кнопка)
          </button>

          <button
            onClick={() =>
              handleRebindDevice("test-device-id", testHolders[0].id)
            }
            style={{
              padding: "0.5rem 1rem",
              background: "var(--accent-success)",
              color: "#ffffff",
              border: "none",
              borderRadius: "0.375rem",
              cursor: "pointer",
            }}
          >
            Тест перепривязки (зеленая кнопка)
          </button>
        </div>
      </TestSection>

      {/* Модальное окно */}
      <QRBindingModal
        isOpen={deviceModal.isOpen}
        onClose={closeDeviceModal}
        holderId={deviceModal.holderId}
        holderName={deviceModal.holderName}
        deviceId={deviceModal.deviceId}
        deviceInfo={deviceModal.deviceInfo}
      />
    </TestContainer>
  );
};

export default DeviceTestPage;





